import { getRegisterFunction } from '../../utils/register.js';
import { OneUxScrollElement } from './OneUxScrollElement.js';
export const register = getRegisterFunction(OneUxScrollElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-scroll': OneUxScrollElement;
    "scroll-8dacb579837ea49d13b4662e5ccc81d4": OneUxScrollElement;
  }
}